@if (processedRightContent && !categoryWidgets) {
  <div
    class="wysiwyg table w-full"
    [innerHTML]="processedRightContent"
  ></div>
}
@if (categoryWidgets) {
  <category-widget [data]="data" [categoryWidgets]="categoryWidgets"></category-widget>
}
@if (processedBottomRightContent) {
  <div
    (click)="activateModalWrapper($event)"
    class="wysiwyg noborder w-full flex text-base mt-v-spacing"
    >
    @for (content of processedBottomRightContent; track content) {
      <div class="flex w-full my-1">
        <span class="top-product__img-container">
          @if (
            content.sealIcon &&
            content.sealIcon.length > 0 &&
            content.sealIcon[0].url !== null
            ) {
            <img
              class="top-product__img w-full lg:order-none order-last"
              [src]="imgixService.buildImgixUrl(content.sealIcon[0].url)"
              [alt]="content.sealIcon[0].altText"
              width="60"
              height="60"
              preloadImg
              />
          }
        </span>
        <span [innerHTML]="content.sealIconText" class="flex text-sm items-center"></span>
      </div>
    }
  </div>
}
